export default __webpack_public_path__ + "static/media/image 29.380f8d3c.png";